module.exports = __webpack_public_path__ + "img/HQTS-black.9ec6f903.png";